import moment from "moment";
import { getChannels, getChannelGenres, getProgramsById } from "./ltv";
import { getReadScope } from "../../utils/readCache";

export const canPrewarmGuide = () => {
  const connection = navigator.connection;
  return (
    navigator.onLine !== false &&
    document.visibilityState !== "hidden" &&
    !connection?.saveData &&
    !["slow-2g", "2g"].includes(connection?.effectiveType)
  );
};

let warming = null;
export const prewarmGuide = ({ cancelled = () => false } = {}) => {
  if (!canPrewarmGuide() || cancelled()) return Promise.resolve();
  const scope = getReadScope();
  const date = moment().format("DD.MM.YYYY");
  if (warming?.scope === scope && warming.date === date) return warming.promise;
  const valid = () =>
    !cancelled() && scope === getReadScope() && canPrewarmGuide();
  const job = { scope, date };
  job.promise = (async () => {
    const response = await getChannels();
    if (!valid()) return;
    const channels = response.data.slice(0, 6);
    let index = 0;
    const worker = async () => {
      while (valid() && index < channels.length) {
        const channel = channels[index++];
        await getProgramsById(channel.id, date).catch(() => {});
      }
    };
    // Two speculative EPG requests at most; leave capacity for user navigation.
    await Promise.all([getChannelGenres().catch(() => {}), worker(), worker()]);
  })()
    .catch(() => {})
    .finally(() => {
      if (warming === job) warming = null;
    });
  warming = job;
  return job.promise;
};

export const onGuideIntent = () => {
  prewarmGuide();
};
